import ClusterMap from "./ClusterMaps";
import FarmersTable from "./FarmersTable";
import sprayLogs from "./../../data/spraylogs.json";
import farmerData from "./../../data/farmers.json";
import Analytics from "./Analytics";

const TabsComponent = ({ currentTab }) => {
  let combinedData = farmerData.map((farmer) => {
  const log = sprayLogs.find(
    (f) =>
      f.farmerName.trim().toLowerCase() ===
      farmer.farmerName.trim().toLowerCase()
  );

  return {
    ...farmer,
    // fpcfpoName: log ? log.fpcfpoName : farmer.fpcfpoName,
    // droneSprayStatus: log ? log.droneSprayStatus : "Pending",
    // sprayCycle: log ? log.sprayCycle : "Not Available",
    // dateOfSpraying: log ? log.dateOfSpraying : "Not Available",
    // dosage: log ? log.dosage : "Not Available",

    // // IMPORTANT: match the table fields
    // areasprayed: log ? log.areaSprayed : "Not Available",
    // pestInterveningActivity: log ? log.pestInterveningActivity : "Not Available",
    // nameofproductsprayed: log ? log.productName : "Not Available",

    // cropStage: log ? log.cropStage : "Not Available",
  };
});


  return (
    <div className="w-full">
      <div>
        {currentTab === "farmers" && (
          <FarmersTable combinedData={combinedData} />
        )}

        {currentTab === "map" && (
          <ClusterMap combinedData={combinedData} />
        )}

        {currentTab === "analytics" && (
          <Analytics combinedData={combinedData} />
        )}
      </div>
    </div>
  );
};

export default TabsComponent;
